// @flow
import * as React from 'react';
import classnames from 'classnames';

import css from './group.module.scss';
import customThemeCss from '../../../components/new-file-request-builder/file-request-builder-custom-theme.module.scss';
import { getTitleContainerId } from '../../utils/group';

type Props = {
  components: React.Node,
  description?: React.Node,
  id: string,
  inFocus: boolean,
  label?: React.Node,
  onBlur?: Function,
  onClick?: Function,
  onKeyDown?: Function,
};

const Group = React.memo<Props>((props: Props) => {
  const {
    id,
    label,
    description,
    components,
    inFocus,
    onBlur,
    onClick,
    onKeyDown,
  } = props;

  return (
    <>
      <div
        className={classnames('group-title-container', {
          'selected-field': inFocus,
          [customThemeCss.customThemeBoxShadow]: inFocus,
        })}
        id={getTitleContainerId(id)}
        onBlur={onBlur}
        onClick={onClick}
        onKeyDown={onKeyDown}
        role="button"
        tabIndex={0}
      >
        {label ? <div className={css.groupLabel}>{label}</div> : null}
        {description ? (
          <div className={css.groupDescription}>{description}</div>
        ) : null}
      </div>
      {components}
    </>
  );
});

export { Group };
export default Group;
